(function () {
  if (window.__douxcouChromeCart) return;
  window.__douxcouChromeCart = true;

  const D = () => window.Douxcou || {};
  const FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function trapTab(e, container) {
    if (e.key !== "Tab") return;
    const items = [...container.querySelectorAll(FOCUSABLE)].filter((el) => el.offsetParent !== null);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  class CozyHeader extends HTMLElement {
    connectedCallback() {
      this.sticky = this.closest(".shopify-section") || this;
      this.drawer = this.querySelector(".cozy-drawer");
      this.burger = this.querySelector("[data-menu-open]");
      this.lastY = window.scrollY;
      this.raf = 0;

      this.onScroll = () => {
        if (!this.raf) this.raf = requestAnimationFrame(() => this.update());
      };
      window.addEventListener("scroll", this.onScroll, { passive: true });

      this.burger?.addEventListener("click", () => this.openMenu());
      this.querySelectorAll("[data-menu-close]").forEach((el) => el.addEventListener("click", () => this.closeMenu()));
      this.querySelectorAll("[data-menu-link]").forEach((el) => el.addEventListener("click", () => this.closeMenu(false)));

      this.onKey = (e) => {
        if (!this.classList.contains("is-menu-open")) return;
        if (e.key === "Escape") this.closeMenu();
        else trapTab(e, this.drawer);
      };
      document.addEventListener("keydown", this.onKey);

      this.querySelector("[data-search-open]")?.addEventListener("click", (e) => {
        if (!D().search) return;
        e.preventDefault();
        D().search.open();
      });

      this.querySelector("[data-cart-open]")?.addEventListener("click", (e) => {
        if (!D().drawer) return;
        e.preventDefault();
        D().drawer.open();
      });
    }

    disconnectedCallback() {
      window.removeEventListener("scroll", this.onScroll);
      document.removeEventListener("keydown", this.onKey);
      if (this.raf) cancelAnimationFrame(this.raf);
    }

    update() {
      this.raf = 0;
      const y = window.scrollY;
      const mobile = window.innerWidth < 750;
      const headerBottom = (mobile ? 40 : 50) + this.sticky.offsetHeight;
      const cl = this.sticky.classList;
      if (y <= headerBottom) {
        cl.remove("is-hidden", "is-animated");
      } else if (y > this.lastY) {
        if (!this.classList.contains("is-menu-open")) cl.add("is-hidden", "is-animated");
      } else if (y < this.lastY) {
        cl.remove("is-hidden");
        cl.add("is-animated");
      }
      this.lastY = y;
    }

    openMenu() {
      this.classList.add("is-menu-open");
      this.burger?.setAttribute("aria-expanded", "true");
      requestAnimationFrame(() => this.drawer?.querySelector("button")?.focus());
    }

    closeMenu(restoreFocus = true) {
      if (!this.classList.contains("is-menu-open")) return;
      this.classList.remove("is-menu-open");
      this.burger?.setAttribute("aria-expanded", "false");
      if (restoreFocus) this.burger?.focus();
    }
  }
  if (!customElements.get("cozy-header")) customElements.define("cozy-header", CozyHeader);

  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.inner = this.querySelector(".cd-inner");
      this.enabled = this.dataset.drawerEnabled !== "false";

      this.onOpen = () => this.open();
      this.onClose = () => this.close();
      document.addEventListener("cart-drawer:open", this.onOpen);
      document.addEventListener("cart-drawer:close", this.onClose);

      this.addEventListener("click", (e) => {
        if (e.target === this || e.target.closest("[data-cart-close]")) {
          e.preventDefault();
          this.close();
          // Panier vide : « Continuer mes achats » ramène sur les 3 offres (sur la fiche, ou en y allant)
          const go = e.target.closest && e.target.closest("[data-go-offres]");
          if (go) {
            const offres = document.getElementById("offres");
            if (offres) offres.scrollIntoView({ behavior: "smooth", block: "start" });
            else window.location.href = go.getAttribute("href");
          }
        }
      });

      this.onKey = (e) => {
        if (!this.classList.contains("is-open")) return;
        if (e.key === "Escape") this.close();
        else trapTab(e, this.inner);
      };
      document.addEventListener("keydown", this.onKey);
    }

    disconnectedCallback() {
      document.removeEventListener("cart-drawer:open", this.onOpen);
      document.removeEventListener("cart-drawer:close", this.onClose);
      document.removeEventListener("keydown", this.onKey);
    }

    open() {
      if (!this.enabled) {
        window.location.href = this.dataset.cartUrl || "/cart";
        return;
      }
      if (this.classList.contains("is-open")) return;
      this.opener = document.activeElement;
      this.classList.add("is-open");
      this.setAttribute("aria-hidden", "false");
      document.body.classList.add("cd-is-open");
      applyOrder();
      D().lockScroll?.(true);
      setTimeout(() => (this.inner.querySelector(".cd-close") || this.inner).focus(), 50);
    }

    close() {
      if (!this.classList.contains("is-open")) return;
      this.classList.remove("is-open");
      this.setAttribute("aria-hidden", "true");
      document.body.classList.remove("cd-is-open");
      D().lockScroll?.(false);
      if (this.opener && document.contains(this.opener)) this.opener.focus();
      this.opener = null;
    }
  }
  if (!customElements.get("cart-drawer")) customElements.define("cart-drawer", CartDrawer);

  // Boutons +/− : le chiffre change tout de suite, les taps rapides sont regroupés en une seule requête
  const qtyState = {};
  const sendQty = async (key, sectionId) => {
    const st = qtyState[key];
    if (st.inflight) return;
    st.inflight = true;
    const sent = st.target;
    try {
      await D().cart.change(key, sent);
    } catch (err) {
      console.error(err);
      window.alert(err.message || "Impossible de modifier le panier.");
      st.target = sent;
    }
    st.inflight = false;
    const target = sectionId ? document.querySelector(`[data-cart-section="${sectionId}"]`) : null;
    if (st.target !== sent) {
      // Nouveaux taps pendant la requête : on réaffiche le chiffre voulu et on renvoie
      target?.querySelectorAll(`[data-cart-change="${CSS.escape(key)}"][data-step]`).forEach((b) => {
        const v = b.parentElement.querySelector("[data-qty-value]");
        if (v) v.textContent = st.target;
      });
      return sendQty(key, sectionId);
    }
    delete qtyState[key];
    target?.classList.remove("is-updating");
    const again = st.focusId && target?.querySelector(`[data-focus-id="${CSS.escape(st.focusId)}"]`);
    if (again) again.focus();
  };

  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-cart-change][data-step]");
    if (!btn || !D().cart) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const key = btn.dataset.cartChange;
    const section = btn.closest("[data-cart-section]");
    const value = btn.parentElement.querySelector("[data-qty-value]");
    const st = (qtyState[key] = qtyState[key] || { target: parseInt(value?.textContent, 10) || 0 });
    st.target = Math.max(0, st.target + parseInt(btn.dataset.step, 10));
    st.focusId = btn.dataset.focusId;
    if (value) value.textContent = st.target;
    section?.classList.add("is-updating");
    clearTimeout(st.timer);
    st.timer = setTimeout(() => sendQty(key, section?.dataset.cartSection), st.target === 0 ? 0 : 250);
  }, true);

  // Pastilles de couleur du panier : l'écran change tout de suite, le panier suit en 1 requête quand on arrête de toucher
  // (même quantité totale, donc même prix de lot)
  const recolor = { wanted: null, timer: 0, inflight: false };
  const paintUnits = (wanted) =>
    document.querySelectorAll("cart-drawer [data-unit]").forEach((unit, i) => {
      const id = wanted[i];
      if (!id) return;
      unit.dataset.variant = id;
      unit.querySelectorAll("[data-cart-recolor]").forEach((b) => {
        const on = b.dataset.to === id;
        b.setAttribute("aria-pressed", String(on));
        b.style.boxShadow = on ? "0 0 0 2px #fff, 0 0 0 4px var(--accent-color, #b84a33)" : "none";
        if (on) unit.querySelector("[data-unit-name]").textContent = b.dataset.name;
      });
    });
  const syncColours = async () => {
    if (recolor.inflight) return;
    recolor.inflight = true;
    const sent = recolor.wanted.slice();
    const updates = {};
    document.querySelectorAll("cart-drawer [data-cart-recolor]").forEach((b) => (updates[b.dataset.to] = 0));
    sent.forEach((id) => (updates[id] = (updates[id] || 0) + 1));
    try {
      await D().cart.update(updates);
    } catch (err) {
      console.error(err);
      window.alert(err.message || "Impossible de changer la couleur.");
    }
    recolor.inflight = false;
    keepOrder(recolor.wanted);
    if (recolor.wanted.join() !== sent.join()) return syncColours();
    recolor.wanted = null;
  };
  // Shopify renvoie les lignes dans son ordre à lui : sans ça, changer l'écharpe 1 pouvait inverser l'affichage des écharpes 1 et 2
  const ORDER_KEY = "dc-colour-order";
  const keepOrder = (order) => {
    try {
      sessionStorage.setItem(ORDER_KEY, JSON.stringify(order));
    } catch (e) {}
    applyOrder();
  };
  const applyOrder = () => {
    let order;
    try {
      order = JSON.parse(sessionStorage.getItem(ORDER_KEY) || "null");
    } catch (e) {}
    const units = [...document.querySelectorAll("cart-drawer [data-unit]")];
    if (!order || order.length !== units.length) return;
    // Même contenu de panier (les mêmes couleurs) : on réaffiche dans l'ordre choisi
    if (units.map((u) => u.dataset.variant).sort().join() !== order.slice().sort().join()) return;
    paintUnits(order);
    // Les articles en dessous suivent le même ordre : l'écharpe 1 d'abord, puis la 2…
    const list = document.querySelector("cart-drawer .cd-items");
    if (!list) return;
    const rank = (li) => {
      const i = order.indexOf(li.dataset.lineVariant);
      return i < 0 ? order.length : i;
    };
    [...list.children].sort((a, b) => rank(a) - rank(b)).forEach((li) => list.appendChild(li));
  };
  document.addEventListener("cart:updated", () => {
    if (!recolor.inflight) applyOrder();
  });
  document.addEventListener("click", (e) => {
    const sw = e.target.closest("[data-cart-recolor]");
    if (!sw || !D().cart) return;
    e.preventDefault();
    const units = [...document.querySelectorAll("cart-drawer [data-unit]")];
    const unit = sw.closest("[data-unit]");
    recolor.wanted = recolor.wanted || units.map((u) => u.dataset.variant);
    recolor.wanted[units.indexOf(unit)] = sw.dataset.to;
    paintUnits(recolor.wanted);
    clearTimeout(recolor.timer);
    recolor.timer = setTimeout(syncColours, 400);
  });

  document.addEventListener("click", async (e) => {
    const btn = e.target.closest("[data-cart-change]");
    if (!btn || !D().cart) return;
    e.preventDefault();
    const section = btn.closest("[data-cart-section]");
    const sectionId = section?.dataset.cartSection;
    const focusId = btn.dataset.focusId;
    section?.classList.add("is-loading");
    try {
      await D().cart.change(btn.dataset.cartChange, Math.max(0, parseInt(btn.dataset.quantity, 10) || 0));
    } catch (err) {
      console.error(err);
      window.alert(err.message || "Impossible de modifier le panier.");
    } finally {
      const target = sectionId ? document.querySelector(`[data-cart-section="${sectionId}"]`) : null;
      target?.classList.remove("is-loading");
      if (target) {
        const again = focusId && target.querySelector(`[data-focus-id="${CSS.escape(focusId)}"]`);
        if (again) again.focus();
        else if (target.closest("cart-drawer")) (target.querySelector(".cd-close") || target).focus();
      }
    }
  });

  class ScrollToTop extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector("button");
      this.raf = 0;
      const update = () => {
        this.raf = 0;
        this.button.classList.toggle("is-visible", window.scrollY > 400);
      };
      this.onScroll = () => {
        if (!this.raf) this.raf = requestAnimationFrame(update);
      };
      update();
      window.addEventListener("scroll", this.onScroll, { passive: true });
      this.button.addEventListener("click", () => window.scrollTo({ top: 0, behavior: "smooth" }));
    }
    disconnectedCallback() {
      window.removeEventListener("scroll", this.onScroll);
    }
  }
  if (!customElements.get("scroll-to-top")) customElements.define("scroll-to-top", ScrollToTop);

  function initReveal(root = document) {
    const els = root.querySelectorAll("[data-cozy-reveal]:not(.reveal-shown)");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("reveal-shown"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("reveal-shown");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    els.forEach((el) => io.observe(el));
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => initReveal());
  else initReveal();
  document.addEventListener("shopify:section:load", (e) => initReveal(e.target));
})();
